export enum CookieName {
  REFRESH_TOKEN = 'user-refresh-token',
  USER_ID_TOKEN = 'user-id-token',
  USER_ACCESS_TOKEN = 'user-access-token',
  COMPANY = 'company',
  COMPANY_LANG = 'companyLang',
  TRAVELER_COMPANIONS = 'travelerCompanions',
  COMPANY_DATA = 'companyData',
  USER_ID = 'userId',
}
